export function autoDetectCourier(waybillId) {
  if (waybillId.substr(0, 1) === "J") return "jnt";
  if (waybillId.substr(0, 2) === "00") return "sicepat";
  if (waybillId.substr(0, 1) === "0") return "jne";
  if (waybillId.substr(0, 2) === "GK") return "gojek";
  if (waybillId.substr(0, 2) === "IN" || waybillId.substr(0, 2) === "SD") return "grab";
  if (waybillId.substr(0, 4) === "TIKI") return "tiki";
  if (waybillId.substr(0, 5) === "BITES") return "ninja";
  if (waybillId.substr(0, 3) === "IDE") return "idexpress";
  if (waybillId.substr(0, 3) === "100") return "anteraja";
  if (waybillId.substr(0, 3) === "BTS") return "sap";
  if (waybillId.substr(0, 4) === "SWFT") return "paxel";
  if (waybillId.substr(0, 3) === "JXE") return "jdl";
  if (waybillId.substr(0, 2) === "99") return "lion";
  if (waybillId.substr(0, 2) === "79") return "rpx";

  return "nomatch";
}
